import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Divider, Space, Statistic, Table } from 'antd';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  ReloadOutlined,
} from '@ant-design/icons';

import { LineChart } from 'react-chartkick';
import 'chart.js';

import {
  prepareGraphData,
  selectActiveTransactions,
  selectStatsStatus,
  selectStats,
  selectBTCGraphData,
  selectFiatGraphData,
  fetchStats,
} from './processorSlice';

import styles from './Processor.css';

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    sorter: (a, b) => a.date - b.date,
    multiple: 1,
  },
  {
    title: 'BTC Price',
    dataIndex: 'exchangRate',
    key: 'exchangRate',
    sorter: (a, b) => a.exchangRate - b.exchangRate,
    multiple: 2,
  },
  {
    title: 'Bitcoin Amount',
    dataIndex: 'btcAmount',
    key: 'btcAmount',
    sorter: (a, b) => a.btcAmount - b.btcAmount,
    multiple: 3,
  },
  {
    title: 'USD Amount',
    dataIndex: 'fiatAmount',
    key: 'fiatAmount',
    sorter: (a, b) => a.fiatAmount - b.fiatAmount,
    multiple: 4,
  },
  {
    title: 'Fee',
    dataIndex: 'fee',
    key: 'fee',
    sorter: (a, b) => a.fee - b.fee,
    multiple: 5,
  },
  {
    title: 'Exchange',
    dataIndex: 'exchange',
    key: 'exchange',
    sorter: (a, b) => a.exchange - b.exchange,
    multiple: 6,
  },
];

export default function Proccessor() {
  const dispatch = useDispatch();

  const transactions = useSelector(selectActiveTransactions);
  const stats = useSelector(selectStats);
  const priceStatus = useSelector(selectStatsStatus);
  const btcGraphData = useSelector(selectBTCGraphData);
  const fiatGraphData = useSelector(selectFiatGraphData);

  // const dateValues = {}

  // const greatestDay = Object.keys(dateValues).reduce((a, b) =>
  //   dateValues[a]['btcAmount'] > dateValues[b]['btcAmount'] ? a : b
  // );
  // const greatestBtc = dateValues[greatestDay].btcAmount;
  // const greatestFiat = dateValues[greatestDay].fiatAmount;

  useEffect(() => {
    if (priceStatus === 'idle') {
      dispatch(fetchStats(transactions));
      dispatch(prepareGraphData(transactions));
    }
  });

  return (
    <div>
      <div className={styles.container}>
        <Space>
          {/* <Card>
            <Statistic title="Greatest Date" value={greatestDay} />
            <Statistic title="BTC" value={greatestBtc} />
            <Statistic title="Fiat" value={greatestFiat} />
          </Card> */}
          <Card>
            <Statistic title="BTC Purchased" value={stats.btcAmount} />
          </Card>
          <Card>
            <Statistic
              title="USD Value"
              value={stats.fiatValue}
              precision={0}
              suffix="$"
            />
          </Card>
          <Card>
            <Statistic
              title="USD Spent"
              value={stats.fiatSpent}
              precision={0}
              suffix="$"
            />
          </Card>
          <Card>
            <Statistic
              title="USD Gain"
              value={stats.fiatGain}
              precision={0}
              valueStyle={{ color: '#3f8600' }}
              prefix={<ArrowUpOutlined />}
              suffix="$"
            />
          </Card>
          <Card>
            <Statistic
              title="% Gain"
              value={stats.percentGain}
              precision={0}
              valueStyle={{ color: '#3f8600' }}
              prefix={<ArrowUpOutlined />}
              suffix="%"
            />
          </Card>
          <Card className={styles.priceContainer}>
            <Statistic
              title={`BTC @ ${stats.lastUpdate}`}
              value={stats.currentPrice}
              precision={0}
              suffix="$"
            />
            <ReloadOutlined
              className={styles.reload}
              onClick={() => dispatch(fetchStats(transactions))}
            />
          </Card>
        </Space>
        <Divider />
        <Card title="BTC Over Time">
          <LineChart data={btcGraphData} xtitle="Date" ytitle="BTC Amount" />
        </Card>
        <Divider />
        <Card title="USD Over Time">
          <LineChart data={fiatGraphData} xtitle="Date" ytitle="USD Amount" />
        </Card>
        {/* <Divider />
        <Table
          scroll={{ x: 'calc(700px + 50%)', y: 350 }}
          columns={columns}
          dataSource={transactions}
        /> */}
      </div>
    </div>
  );
}
